import axios from "axios";
import store from '@/store';

const siteId = () => {
  return store.getters.currentLang === 'CN' ? "F01" : "F02";
};
const service = axios.create({
  baseURL: "/prod-api",
  timeout: 3000,
  dataType: 'json',
  headers: { "Content-Type": "application/json" },
});

let needLoadingRequestCount = 0;
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
  }
}

// 请求拦截器
service.interceptors.request.use(
  async (config) => {
    showFullScreenLoading();

    // 获取siteId值
    const currentSiteId = siteId();

    // 处理 GET 请求的参数 (params)
    if (config.method?.toLowerCase() === 'get') {
      config.params = {
        siteId: currentSiteId,
        ...config.params // 保留原有参数，siteId会覆盖同名参数（如果有）
      };
    }
    // 处理 POST/PUT/DELETE 等请求的请求体 (data)
    else if (config.data) {
      // 如果是 FormData 格式（文件上传等场景）
      if (config.data instanceof FormData) {
        config.data.append('siteId', currentSiteId);
      }
      // 如果是普通 JSON 格式
      else {
        config.data = {
          siteId: currentSiteId,
          ...config.data 
        };
      }
    }
    else {
      config.data = {
        siteId: currentSiteId
      };
    }

    return config;
  },
  (error) => {
    // 发送失败
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (!sessionStorage.getItem("SERVER_TYPE")) {
      sessionStorage.setItem("SERVER_TYPE", response.headers["server"]);
    }
    tryHideFullScreenLoading();

    return response.data;
  },
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          error.message = "未授权，请登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器内部错误";
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          break;
      }
    }
    // 响应失败时也要关闭loading
    tryHideFullScreenLoading();
    return Promise.reject(error);
  }
);

export default service;